module.exports = __webpack_public_path__ + "static/img/icon-psd.ce6f8aa5.svg";